import { Component } from '@angular/core';

@Component({
  selector: 'unh-nav-item-divider',
  styleUrls: ['./nav-item-divider.component.scss'],
  template: `
    <div class="nav-item-divider"></div>
  `
})
export class NavItemDividerComponent {}
